import { AccountInformationData } from "../component/AccountInformation/AccountInformation.data";
import { CompanyDetailsFormData } from "../component/CompanyDetails/CompanyDetails.data";
import { MembershipSubscriptionData } from "../component/MembershipSubscription/MembershipSubscription.data";
import { DiscontinueApplicationdata } from "../data/DiscontinueApplication.data";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "membershipTypeId": filterDropDownList("Membership Type"),
        "membershipStatusId": filterDropDownList("Tasklist Membership Status"),
        "typeofCompany": filterDropDownList("Type Of Company"),
        "organisationProfile": filterDropDownList("Organisation Profile"),
        "businessCategories": filterDropDownList("Business Category"),
        "organisationCategory": filterDropDownList("Org Category"),
        "pspcListedOrganisation": filterDropDownList("PSPC Org"),
        "howdidyoulearnaboutsgbc": filterDropDownList("Learn About SGBC"),
        "reasonforjoiningSGBCCorporateMembership": filterDropDownList("Reason Of Joining"),
        "subscriptionType": filterDropDownList("Subscription Type"),
        "billingCategory": filterDropDownList("Billing Category"),
        "applicationType": filterDropDownList("Application Type"),
        "applicationTerm": filterDropDownList("Application Terms"),
        "linkedMember": filterDropDownList("Company Name"),
        "discontinueReasonId": filterDropDownList("Discontinue Reason"),
        // "productsandServicesOfferedbyOrganisation": filterDropDownList("Product And Service"),
    };

    const formFields = [...AccountInformationData.formFields, ...CompanyDetailsFormData.formFields, ...MembershipSubscriptionData.formFields, ...DiscontinueApplicationdata.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};